var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoego(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 113 113",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_82",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 82",
    x1: 48.41,
    y1: 7.19,
    x2: 63.93,
    y2: 83.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eef2f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#f7f9fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M36.45,97.66a24.67,24.67,0,0,0-10-4.73A21.2,21.2,0,0,1,10.16,72.32V22A21.18,21.18,0,0,1,31.34.82H81.66A21.18,21.18,0,0,1,102.84,22V72.32A21.2,21.2,0,0,1,86.51,92.93a24.67,24.67,0,0,0-10,4.73L60.46,110.77a6.27,6.27,0,0,1-7.92,0Z",
    fill: "#ceb01d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.51,10.2H81.66A11.8,11.8,0,0,1,93.46,22V72.32a11.8,11.8,0,0,1-11.8,11.8H31.34a11.8,11.8,0,0,1-11.8-11.8V22.17a12,12,0,0,1,12-12Z",
    fill: "url(#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_82)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M34.15,24.31a17.86,17.86,0,0,0-2.1.69A13.3,13.3,0,0,0,25.83,31a10.8,10.8,0,0,0-1.33,5.92,8.55,8.55,0,0,0,.56,3.79c.78,2.3,1.75,3.75,4.26,6.34l2.16,2.24-1.26,5.43c-.7,3-1.25,5.45-1.23,5.47s.88.1,1.91.18l1.88.14-1.67,4.22C30.2,67,29.47,69,29.49,69s2.71-3.13,6-7.12l5.92-7.25h-4.1l5-5.1c5.48-5.52,5.85-6.08,6.87-8.76a12.77,12.77,0,0,0-8.4-16.3A15,15,0,0,0,34.15,24.31ZM44,36.76a6.77,6.77,0,1,1-6.77-6.82A6.79,6.79,0,0,1,44,36.76Z",
    fill: "#ceb01d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.86,57.15a4.1,4.1,0,0,1-3.17,1.11h0a7.15,7.15,0,0,1-3.62-.92l.85-1.83a4.6,4.6,0,0,0,2.52.76,1.72,1.72,0,0,0,1.89-2V54a2.68,2.68,0,0,1-2.25,1.21c-1.77,0-3.2-1.43-3.2-3.73v0c0-2.31,1.43-3.74,3.12-3.74a2.87,2.87,0,0,1,1.26.29,2.71,2.71,0,0,1,1,.82v-.95H52.8v6.09A4.5,4.5,0,0,1,51.86,57.15Zm-3.62-4.29a1.36,1.36,0,0,0,.6.11h0a1.45,1.45,0,0,0,1.07-.47,1.51,1.51,0,0,0,.31-.5,1.66,1.66,0,0,0,.08-.58v0a1.41,1.41,0,0,0-.08-.58,1.49,1.49,0,0,0-.31-.51A1.54,1.54,0,0,0,49.4,50a1.49,1.49,0,0,0-1.17,0,1.46,1.46,0,0,0-.5.35,1.36,1.36,0,0,0-.31.5,1.49,1.49,0,0,0-.09.59v0a1.49,1.49,0,0,0,.09.59,1.52,1.52,0,0,0,.32.51A1.41,1.41,0,0,0,48.24,52.86Z",
    fill: "#ceb01d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.85,51.85a4.06,4.06,0,0,1-4,4.2v0a4.19,4.19,0,1,1,4-4.2Zm-5.13,1.21a1.75,1.75,0,0,0,1.13.6l0,0a1.61,1.61,0,0,0,1.51-1.78,1.78,1.78,0,0,0-.07-.65,1.61,1.61,0,0,0-.32-.57,1.57,1.57,0,0,0-.51-.41,1.75,1.75,0,0,0-.64-.18,1.6,1.6,0,0,0-1.51,1.78v0A1.68,1.68,0,0,0,56.72,53.06Z",
    fill: "#ceb01d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.48,57.15a4.13,4.13,0,0,1-3.17,1.11h0a7.15,7.15,0,0,1-3.62-.92l.85-1.85a4.57,4.57,0,0,0,2.52.75,1.72,1.72,0,0,0,1.89-2V54a2.73,2.73,0,0,1-1,.88,2.76,2.76,0,0,1-1.28.32c-1.78,0-3.2-1.42-3.2-3.72v0c0-2.32,1.43-3.74,3.12-3.74a2.65,2.65,0,0,1,1.26.29,2.71,2.71,0,0,1,1,.82v-1h2.53v6.1A4.6,4.6,0,0,1,78.48,57.15ZM74.9,52.86a1.35,1.35,0,0,0,.59.11,1.52,1.52,0,0,0,.59-.12,1.38,1.38,0,0,0,.48-.35,1.24,1.24,0,0,0,.31-.5,1.47,1.47,0,0,0,.09-.58v0a1.41,1.41,0,0,0-.09-.58,1.35,1.35,0,0,0-.31-.51,1.5,1.5,0,0,0-.48-.34,1.47,1.47,0,0,0-1.67.35,1.38,1.38,0,0,0-.32.5,1.68,1.68,0,0,0-.08.59v0a1.49,1.49,0,0,0,.09.59,1.45,1.45,0,0,0,.31.5A1.66,1.66,0,0,0,74.9,52.86Z",
    fill: "#ceb01d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.5,51.85a4,4,0,1,1-4-4.2A4,4,0,0,1,88.5,51.85Zm-4.63,1.62a1.77,1.77,0,0,0,.63.19c.93.08,1.51-.85,1.51-1.81a1.65,1.65,0,0,0-.9-1.63,1.7,1.7,0,0,0-.63-.18A1.6,1.6,0,0,0,83,51.82v0a1.52,1.52,0,0,0,.07.64,1.65,1.65,0,0,0,.32.58A1.68,1.68,0,0,0,83.87,53.47Z",
    fill: "#ceb01d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.11,47.94h-7v1.91h7Z",
    fill: "#ceb01d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.1,51h7v1.92h-7Z",
    fill: "#ceb01d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.1,54h7V56h-7Z",
    fill: "#ceb01d"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoego);
export default __webpack_public_path__ + "static/media/Goego.f259d16dd14d3a749f9e243c544d9830.svg";
export { ForwardRef as ReactComponent };